import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { PortalLeave } from "@/components/portal/portal-leave";
import { RequestLeaveDialog } from "@/components/portal/request-leave-dialog";
import { portalLeaveQuery, requirePortalFeature } from "@/lib/portal-data";

export const Route = createFileRoute("/portal/leave")({
  beforeLoad: ({ context }) => requirePortalFeature(context.queryClient, "leave"),
  loader: ({ context }) => context.queryClient.ensureQueryData(portalLeaveQuery),
  component: PortalLeavePage,
});

function PortalLeavePage() {
  const { data: leave } = useQuery(portalLeaveQuery);
  if (!leave) return null;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-3">
        <div className="space-y-1">
          <h1 className="font-heading font-semibold text-2xl tracking-tight">Leave</h1>
          <p className="text-muted-foreground text-sm">
            Request time off and track your balances, pending requests, and history — all in one
            place.
          </p>
        </div>
        <RequestLeaveDialog leave={leave} />
      </div>
      <PortalLeave leave={leave} />
    </div>
  );
}
